export var buildEnv = {
    datacenter: 'us',
    env: 'production',
    version: '1.10.0',
};
//# sourceMappingURL=buildEnv.js.map